module.exports = __webpack_public_path__ + "static/media/soujikiKake.b9648040.png";